import styled, { css } from 'styled-components';

import {
  ButtonSizes,
  ButtonSizesOptions,
  ButtonVariantOptions,
  getButtonVariations,
} from './utils';

export const StyledButton = styled.button<{
  variant: ButtonVariantOptions;
  size: ButtonSizesOptions;
  iconOnLeft?: boolean;
  isSecondaryColor?: boolean;
  outline?: boolean;
  hasHover?: boolean;
  block?: boolean;
  borderRadius?: number;
}>(
  ({
    isSecondaryColor,
    variant,
    iconOnLeft,
    size,
    theme,
    hasHover,
    outline,
    block,
    borderRadius,
  }) =>
    `
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${iconOnLeft ? 'row-reverse' : 'row'};
  transition: all 0.15s;
  cursor: pointer;
  gap: 8px;
  border-radius: ${`${borderRadius ?? 2}px`};
  font-size: 14px;
  height: 32px;
  padding: 4px 15px;
  position: relative;
  white-space: nowrap;
  text-align: center;
  ${ButtonSizes[size]};
  ${getButtonVariations(isSecondaryColor)[variant]?.join('')};
 
  ${
    block
      ? css`
          width: 100%;
        `
      : ''
  } 
  
  ${
    outline
      ? `
          background-color: ${theme.palette.NL0};
          border: 1px solid
            ${isSecondaryColor ? theme.palette.D300 : theme.palette.BR500};
          color: ${isSecondaryColor ? theme.palette.D300 : theme.palette.BR500};
        `
      : ''
  };
          
    &:hover {
      ${
        hasHover
          ? getButtonVariations(isSecondaryColor)[`${variant}-hover`]?.join('')
          : ''
      };
    }
    
      &:disabled {
      box-shadow: none;
      cursor: not-allowed;
      opacity: 0.5;
    }
    
    `
);

export const Loader = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
